export default {
  props: {
    label: {
      type: String,
      default: null,
      required: false,
    },
    value: {
      type: [Boolean, Number, String],
      default: null,
      required: true,
    },
    inline: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    inputAttrs() {
      return {
        ...this.$attrs,
        onChange: () => this.change(),
      };
    },
  },
};
